import { render, staticRenderFns } from "./TableChicksSpare.vue?vue&type=template&id=818fe38a&scoped=true"
import script from "./TableChicksSpare.vue?vue&type=script&lang=js"
export * from "./TableChicksSpare.vue?vue&type=script&lang=js"
import style0 from "./TableChicksSpare.vue?vue&type=style&index=0&id=818fe38a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "818fe38a",
  null
  
)

export default component.exports